// extracted by mini-css-extract-plugin
export default {"top-navigation":"TopNavigation_top-navigation__BCzTE","notification-link":"TopNavigation_notification-link__TM40f"};